import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import axios from "../../../axios";
import { profilePicValidityCheck } from "../../../utils/constants";
import { isMobile } from "../../../utils/deviceInfo";
import * as url from "../../../utils/url";
import moment from "moment";

function GroupOwnerSelector({ open, onClose, group,handleUpdateOwner, ...props }) {
  const [members, setMembers] = useState([]);

  useEffect(() => {
    axios
      .post(url.getSingleGroupItems, {
        groupId: group._id,
        modelName: "Users",
        noLoader: true,
        groupDoc: group,
      })
      .then(({ data }) => {
        setMembers(data.data);
      });
  }, []);

  const viewMember = (user) => {
    let link = `/home/${props.user.profile.organizationId._id}/profile/${user.o_id}`;
    props.history.push(link);
  };

  const getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  const selectGroupOwner = (groupUser) =>{
    let payload = {
      role:{value:1,label:"Admin"},
      groupId: group._id,
      userId: groupUser.o_id,
      organizationId: group.organizationId,
      noLoader: true,
      setAsGroupOwner:true
    };
    axios.post(url.changeGroupRole, payload).then(({ data }) => {
      handleUpdateOwner({
        _id:groupUser.o_id,
        profilePic:groupUser.profilePic,
        firstName:groupUser.firstName,
        lastName:groupUser.lastName,
      })
      onClose()
    });
  }

  return (
    <Modal isOpen={open}>
      <ModalHeader toggle={onClose}>Set group admin</ModalHeader>
      <ModalBody>
        <h5>Select one of the member to make them as a group owner</h5>

        <div className="my-3">
          {members.map((item, index) => {
            return (
              <div className="my-3 d-flex align-items-center justify-content-between">
              <div>
                <div
                  className="grp_member_profile_image cursor-pointer"
                  onClick={() => (isMobile ? viewMember(item) : null)}
                >
                  {profilePicValidityCheck(item.profilePic) ? (
                    <div className="list-item__avatar">
                      <img src={item.profilePic} />
                    </div>
                  ) : (
                    <span
                      className="list-item__avatar"
                      data-letters={getInitials(item)}
                    ></span>
                  )}
                </div>
                <div className="grp_member_profile_details">
                  <div
                    className="linkedToolView"
                    onClick={() => viewMember(item)}
                  >
                    {" "}
                    {item.firstName} , {item.lastName}
                  </div>

                  <div className="grp_member_profile_joined">
                    joined {moment(item.dateJoined).format("MMM Do, YYYY")}{" "}
                  </div>
                </div>
                </div>
              
              <div>
                  {
                    group.groupOwner && group.groupOwner._id == item.o_id ? "Group Owner" : <Button onClick={()=>{
                      selectGroupOwner(item)
                    }} size="sm" color="primary">
                        Set as admin
                    </Button>
                  }
                 
              </div>

              </div>
            );
          })}
        </div>
      </ModalBody>
    </Modal>
  );
}

export default withRouter(GroupOwnerSelector);
